import React from 'react';
import { ConfigProvider } from 'antd';
import ptBR from 'antd/locale/pt_BR';
import Router from './routes/Router';
import GeneralContextProvider from './context/GeneralContext/GeneralContextProvider';
import './App.css';

function App() {
  return (
    <ConfigProvider
      locale={ptBR}
      theme={{
        token: {
          colorPrimary: '#1b3663',
          colorLink: '#4a90e2',
          borderRadius: 4,
        },
      }}
    >
      <GeneralContextProvider>
        <Router />
      </GeneralContextProvider>
    </ConfigProvider>
  );
}

export default App;



